module.exports = __webpack_public_path__ + "fonts/AmazonEmber-Regular.aa6c8d2.eot";